
export default function TestimonialsSection() {
  const testimonials = [
    {
      quote: "MandaPost has completely transformed how our agency manages social media for 50+ clients. The intelligent content suggestions save us 20 hours per week, and our client retention has never been higher.",
      author: "Sarah Mitchell",
      role: "CEO, Digital Dynamics Agency",
      company: "New York, NY",
      initials: "SM",
      gradient: "from-purple-500 to-pink-500",
      rating: 5,
    },
    {
      quote: "As a solo content creator, I was drowning in scheduling tools and spreadsheets. MandaPost's AI calendar and Playground feature have tripled my engagement while cutting my planning time in half. It's like having a full marketing team in my pocket.",
      author: "Marcus Rodriguez",
      role: "Content Creator & Influencer",
      company: "Los Angeles, CA",
      initials: "MR",
      gradient: "from-blue-600 to-cyan-500",
      rating: 5,
    },
    {
      quote: "The ROI speaks for itself. Within 3 months of using MandaPost, our social media engagement increased by 240% and we've cut our content creation costs by 60%. The analytics dashboard shows exactly where our success is coming from, and we can finally benchmark against competitors in real-time.",
      author: "Jennifer Chen",
      role: "CMO, TechVenture Inc.",
      company: "San Francisco, CA",
      initials: "JC",
      gradient: "from-green-600 to-teal-500",
      rating: 5,
    },
    {
      quote: "I've tried every social media tool out there, and MandaPost is the only one that truly understands what marketers need. The AI adaptation for different platforms is genius—my LinkedIn posts now sound professional while my TikTok content is perfectly casual.",
      author: "David Thompson",
      role: "Social Media Director",
      company: "Austin, TX",
      initials: "DT",
      gradient: "from-orange-600 to-red-500",
      rating: 5,
    },
    {
      quote: "MandaPost's Kanban board and team collaboration features have revolutionized how our distributed team works together. No more endless email threads or missed approvals. Everything is seamless and intuitive.",
      author: "Emily Watson",
      role: "Marketing Manager, Global Retail Co.",
      company: "Chicago, IL",
      initials: "EW",
      gradient: "from-indigo-600 to-purple-600",
      rating: 5,
    },
    {
      quote: "The Playground feature is a game-changer. I wake up every morning to fresh, relevant content ideas that I would have never thought of on my own. My audience loves the variety and timeliness of my posts now.",
      author: "Alex Kumar",
      role: "Brand Strategist",
      company: "Seattle, WA",
      initials: "AK",
      gradient: "from-teal-600 to-green-600",
      rating: 5,
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#e4f4ff]/30 via-white to-[#b3d9ff]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-[#e4f4ff]/40 rounded-full text-[#22577A] font-medium mb-6">
            <i className="ri-star-fill mr-2 text-yellow-500"></i>
            Customer Success Stories
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-[#22577A] mb-6">
            Trusted by Marketing Leaders
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto">
            Join thousands of marketers who have transformed their workflow with MandaPost's AI-powered platform.
          </p>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          <div className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">10,000+</div>
            <div className="text-gray-600">Active Users</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">240%</div>
            <div className="text-gray-600">Avg. Engagement Increase</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">20hrs</div>
            <div className="text-gray-600">Saved Per Week</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">4.9/5</div>
            <div className="text-gray-600">Average Rating</div>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border-2 border-gray-200 hover:border-[#66b3ff] hover:shadow-xl transition-all p-8 flex flex-col"
            >
              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 leading-relaxed mb-6 flex-grow">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-100">
                <div className={`w-14 h-14 bg-gradient-to-br ${testimonial.gradient} rounded-full flex items-center justify-center flex-shrink-0`}>
                  <span className="text-white text-xl font-bold">{testimonial.initials}</span>
                </div>
                <div>
                  <div className="font-bold text-[#22577A]">{testimonial.author}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                  <div className="text-xs text-gray-500">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-2xl p-8 md:p-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Ready to Join Our Success Stories?
            </h3>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Start your free trial today and see why marketing leaders choose MandaPost
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/pricing"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#22577A] rounded-xl font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all cursor-pointer"
              >
                <i className="ri-vip-crown-line"></i>
                Start Free Trial
              </a>
              <a
                href="/contact"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-xl font-semibold text-lg hover:bg-white/10 transition-all cursor-pointer"
              >
                <i className="ri-calendar-line"></i>
                Schedule Demo
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
